export default {
    valid: state => {
        return state.valid;
    },
}